import NewsSummaryPage from "@components/news/news-summary-page";
import { PageNewsComp } from "@graphql/generated/page";
import { useNewsPageLazyQuery } from "@graphql/generated/graphql";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import LumiNewsArticleJsonLd from "@components/seo/lumi-news-article-json-ld";
import Script from "next/script";
import { NextSeo } from "next-seo";
import { isNewsArticlePage, logNewsEvent } from "@lib/antsomiTracking";

// export const getStaticProps: GetStaticProps = async ({ params, locale }) => {
// const translation = await loadTranslation(
//   locale,
//   process.env.NODE_ENV == "production"
// );

// const {
//   props: { data },
// } = await ssrNews.getServerPage(
//   {
//     variables: {
//       id: params?.id?.toString() || "",
//       languageCode: locale,
//     },
//   },
//   null
// );

// if (!data.news) {
//   const errorMessage = `Error from data news ${params?.id?.toString()}`;
//   const errorDetails = {
//     data: data, errorMessage
//   };
//   // Sentry.captureException(new Error(errorMessage), {
//   //   extra: errorDetails,
//   // });
//   return {
//     notFound: true,
//   };
// }

// return { props: { data, translation } };
// };

// export const getStaticPaths: GetStaticPaths = async () => {
// const {
//   props: { data },
// } = await ssrAllNews.getServerPage({}, null);

// const paths = data.allNews?.map(({ id }) => ({ params: { id } })) || [];

// return {
//   paths,
//   fallback: "blocking",
// };
// };

declare global {
  interface Window {
    AF_SMART_SCRIPT?: any;
  }
}

const News: PageNewsComp = () => {
  const router = useRouter();
  const { locale } = router;

  const [getNews, { data, error, loading, fetchMore }] = useNewsPageLazyQuery();
  const commentsLimit = 3;
  const publisherNewsLimit = 5;

  useEffect(() => {
    getNews({
      variables: {
        id: router.query.id as string,
        commentsLimit: commentsLimit,
        publisherNewsLimit: publisherNewsLimit,
        languageCode: locale,
      },
    });
  }, [getNews, locale, router.query]);

  useEffect(() => {
    if (!router.isReady) return;
    if (!isNewsArticlePage(router.asPath)) return;
    if (!data || !data.news) return;

    logNewsEvent(
      data.news.id,
      data.news.topics.map((topic) => topic.name),
      data.news.newsPublisher.name
    );
  }, [router.isReady, router.asPath, data]);

  function generateSmartScriptOneLink() {
    if (typeof window == "undefined" || !window.AF_SMART_SCRIPT) return "";

    const newsPath = `/news/${router.query.id as string}`;

    //Initializing Smart Script arguments
    var oneLinkURL = "https://luminews.onelink.me/ewC9";
    var webReferrer = "af_channel";
    var mediaSource = { defaultValue: "Switch to App Drawer" };
    var afSub1 = { keys: ["fbclid", "twclid", "ttclid"] };
    var afSub2 = { defaultValue: "social_organic" };
    var campaign = { keys: ["article_id"], defaultValue: newsPath };
    var deepLinkValue = { defaultValue: newsPath };
    var custom_ss_ui = { paramKey: "af_ss_ui", defaultValue: "true" };

    //Call the function after embedding the code through a global parameter on the window object called window.AF_SMART_SCRIPT.
    //Onelink URL is generated.
    var result = window.AF_SMART_SCRIPT.generateOneLinkURL({
      oneLinkURL: oneLinkURL,
      webReferrer: webReferrer,
      afParameters: {
        mediaSource: mediaSource,
        afSub1: afSub1,
        afSub2: afSub2,
        campaign: campaign,
        deepLinkValue,
        afCustom: [custom_ss_ui],
      },
    });

    return result.clickURL;
  }

  return (
    <>
      {data && data.news && (
        <NextSeo
          title={`${data.news.title} | Lumi News`}
          description={data.news.description}
        />
      )}
      <Script src="https://onelinksmartscript.appsflyer.com/onelink-smart-script-latest.js"></Script>
      <LumiNewsArticleJsonLd data={data} />
      <NewsSummaryPage
        onelink={generateSmartScriptOneLink()}
        data={data}
        loading={loading}
        fetchMore={fetchMore}
        limit={commentsLimit}
      />
    </>
  );
};

export default News;
